let _ = require('../_.js');
let $ = jQuery;

_.AuctionUI_Auction_General_UI = class AuctionUI_Auction_General_UI {

    static init() {

        let $view_lots_button = $(".ac-btn-action-view-lots");
        let $signin_button = $(".ac-btn-action-signin-register");
        let $settings_button = $(".ac-btn-action-user-settings");

        $view_lots_button.click(_.AuctionUI_Auction_General_UI.on_click_lots);
        $signin_button.click(_.AuctionUI_Auction_General_UI.on_click_registration);
        $settings_button.click(_.User_Profile_Modal.show_settings_modal);

        _.AuctionUI.on_update_auction_items(function () {
            _.AuctionUI_Auction_General_UI.update_ui();
        });

        _.on_ui_update_once(".ac-magnific-single", function () {
            $(this).magnificPopup({
                type: 'image',
                closeOnContentClick: true,
                image: {
                    verticalFit: false
                }
            });
        });

        // Setup badge text

        let title_text_sold = 'This item has been sold and is no longer available.';
        let title_text_accepting = 'This item is accepting bids now.  Click the bid button below to bid!';
        let title_text_low_bid = 'This Low Bid item will not win the auction unless it is bid up to Top Bid.';
        let title_text_top_bid = 'This Top Bid item will win the auction if it remains Top Bid.';
        let title_text_high_bidder = 'You are the high bidder for this item.';
        let title_text_outbid = 'You have been outbid for this item.';
        let title_text_cancelled = 'This item has been cancelled in this auction and will not be available in this auction again.';
        let title_text_pending = 'This item is a pending staff action.';
        let title_text_paused = 'The bidding for this item has been temporarily paused and will be available in this auction soon.';
        let title_text_once = 'The auctioneer is close to closing this item’s auction.';
        let title_text_twice = 'The auctioneer is calling for last bids on this item.';
        let title_text_finalizing = 'The sale of this item is pending staff review.';
        let title_text_winner = 'You are the high bidder and winner of this tract.';
        let title_text_available = 'This item has not yet sold and is not associated to any Auction Rounds.';

        _.register_dynamic_title_by_class('adge-item-STATUS_SOLD', title_text_sold);
        _.register_dynamic_title_by_class('ac-bids-bigauctionstatus-sold', title_text_sold);

        _.register_dynamic_title_by_class('badge-item-STATUS_ACTIVE', title_text_accepting);
        _.register_dynamic_title_by_class('ac-bids-bigauctionstatus-active', title_text_accepting);
        _.register_dynamic_title_by_class('badge-item-title-accepting', title_text_accepting);

        _.register_dynamic_title_by_class('bid-badge-ent-topbid', title_text_top_bid);
        _.register_dynamic_title_by_class('this-item-is-top-bid', title_text_top_bid);

        _.register_dynamic_title_by_class('bid-badge-ent-lowbid', title_text_low_bid);
        _.register_dynamic_title_by_class('this-item-is-low-bid', title_text_low_bid);

        _.register_dynamic_title_by_class('badge-item-winner', title_text_winner);

        _.register_dynamic_title_by_class('badge-item-high-bidder', title_text_high_bidder);
        _.register_dynamic_title_by_class('bid-badge-highbid', title_text_high_bidder);

        _.register_dynamic_title_by_class('badge-item-outbid', title_text_outbid);
        _.register_dynamic_title_by_class('bid-badge-outbid', title_text_outbid);

        _.register_dynamic_title_by_class('badge-item-STATUS_ONCE', title_text_once);
        _.register_dynamic_title_by_class('bid-badge-once', title_text_once);
        _.register_dynamic_title_by_class('ac-bids-bigauctionstatus-once', title_text_once);

        _.register_dynamic_title_by_class('badge-item-STATUS_TWICE', title_text_twice);
        _.register_dynamic_title_by_class('bid-badge-twice', title_text_twice);
        _.register_dynamic_title_by_class('ac-bids-bigauctionstatus-twice', title_text_twice);

        _.register_dynamic_title_by_class('bid-badge-finalizing', title_text_finalizing);

        _.register_dynamic_title_by_class('badge-item-STATUS_CANCELED', title_text_cancelled);
        _.register_dynamic_title_by_class('bid-badge-canceled', title_text_cancelled);

        _.register_dynamic_title_by_class('badge-item-STATUS_PENDING', title_text_pending);
        _.register_dynamic_title_by_class('ac-bids-bigauctionstatus-pending', title_text_pending);

        _.register_dynamic_title_by_class('badge-item-STATUS_PAUSED', title_text_paused);
        _.register_dynamic_title_by_class('ac-bids-bigauctionstatus-paused', title_text_paused);

        _.register_dynamic_title_by_class('ac-bids-bigauctionstatus-choice-item-is-available-for-bidding', title_text_available);

    }

    static async update_ui() {

        let auction = _.ac_state.auction;
        let items = await auction.auction_items.fetch();

        let $view_lots_button = $(".ac-btn-action-view-lots");
        let $signin_button = $(".ac-btn-action-signin-register");

        if (items.length > 1) {
            $view_lots_button.show();
        } else {
            $view_lots_button.hide();
        }

        if (!auction) {
            _.shouldnt_happen();
            return;
        }

        $("#ac-widget-general-auction-type").text("---");
        $("#ac-widget-general-auction-format").text(auction.auction_format_label);
        $("#ac-widget-general-auction-lots").text(items.length);
        $("#ac-widget-general-auction-status").empty().append($("<div class='badge bg-small'></div>").addClass(auction.auction_status_badge).text(auction.auction_status_label_frontend));

        // Lookup agents, create url xlinks.  Do this async
        (async function () {
            try {
                let property = await auction.property.fetch();
                let agents = await property.agents.fetch();     // Error occasionally happened here, think about it.
                let $la = $("#ac-widget-general-auction-land-agents");
                $la.empty();
                let is_first = true;
                for (let i in agents) {
                    if (!is_first) {
                        $la.append("<span>, </span>");
                    }
                    $la.append($("<a></a>").attr('href', _.AuctionUI_Agents.profile_url(agents[i])).text(agents[i].first_name + " " + agents[i].last_name).attr("target", "_blank"));
                    is_first = false;
                }
            } catch (e) {
                console.error(e);
            }
        }());

        let registrant = await _.AuctionUI_Session.get_registrant();
        let backendUser = _.AuctionUI_Session.get_backend_user();
        let $registration_button = $("#ac-widget-general-auction-registration");

        if (!registrant && !backendUser) {
            $registration_button.text("Not Signed In").css("color", "black").css('font-weight', 'normal');
        } else if (backendUser && !registrant) {
            $registration_button.text("Backend Admin User").css("color", "blue").css('font-weight', 'bold');
        } else if (!_.ac_state.registration) {
            $registration_button.text("Not Registered For Auction").css("color", "black").css('font-weight', 'normal');
        } else if (!_.ac_state.registration.approved) {
            $registration_button.text("Registration Pending Approval").css("color", "gray").css('font-weight', 'bold');
        } else {
            $registration_button.text("Approved to Bid").css("color", "green").css('font-weight', 'bold');
        }

        if (registrant && _.ac_state.registration && _.ac_state.registration.approved) {
            $("#ac-widget-general-auction-paddle-container").show();
            $("#ac-widget-general-auction-paddle")
                .empty()
                .append($("<i class='fa-solid fa-user' style='margin-right:3px;'></i>"))
                .append((_.ac_state.registration && _.ac_state.registration.paddle_number) ? $("<strong>[" + _.ac_state.registration.paddle_number + "]</strong>") : "")
        } else {
            $("#ac-widget-general-auction-paddle-container").hide();
        }

        if (_.AuctionUI.auction_is_sealed_bid()) {
            $signin_button.hide();
        } else if (auction.auction_status == App_Models_Auction.STATUS_ACTIVE) {
            if (registrant && _.ac_state.registration && _.ac_state.registration.approved) {
                $signin_button.hide();
            } else if (registrant && _.ac_state.registration && !_.ac_state.registration.approved) {
                $signin_button.show();
                $signin_button.removeClass("btn-success").addClass("btn-secondary");
                $signin_button.text("Registration Pending");
            } else {
                $signin_button.show();
                $signin_button.removeClass("btn-secondary").addClass("btn-success");
                $signin_button.text("Register To Bid")
            }
        } else if (auction.auction_status == App_Models_Auction.STATUS_COMPLETE ||
            auction.auction_status == App_Models_Auction.STATUS_CANCELED ||
            auction.auction_status == App_Models_Auction.STATUS_CONTRACT) {
            $signin_button.show();
            $signin_button.removeClass("btn-success").addClass("btn-secondary");
            $signin_button.text("Bidding Is Closed")
        } else {
            if (registrant && _.ac_state.registration && _.ac_state.registration.approved) {
                $signin_button.hide();
            } else if (registrant && _.ac_state.registration && !_.ac_state.registration.approved) {
                $signin_button.show();
                $signin_button.removeClass("btn-success").addClass("btn-secondary");
                $signin_button.text("Registration Pending");
            } else {
                $signin_button.show();
                $signin_button.removeClass("btn-secondary").addClass("btn-success");
                $signin_button.text("Pre-Register To Bid")
            }
        }

        $(".ac-component-auction-completed-notice").set_conditional_visibility(auction.auction_status == App_Models_Auction.STATUS_COMPLETE);
        $(".ac-component-auction-closed-notice").set_conditional_visibility(auction.auction_status == App_Models_Auction.STATUS_CANCELED);

        if ($(".component-flag-active").is(":visible")) {
            if (auction.auction_status == App_Models_Auction.STATUS_COMPLETE) {
                $(".component-flag-active").hide();
                $(".component-flag-sold").show();
                $(".addtocalendar").hide();
            }
            if (auction.auction_status == App_Models_Auction.STATUS_CONTRACT) {
                $(".component-flag-active").hide();
                $(".component-flag-contract").show();
                $(".addtocalendar").hide();
            }
        }

        let $bban = $(".ac-component-bid-auction-lots-items-bidding-banner");

        $bban.removeClass("bban-active");
        $bban.removeClass("bban-closed");

        if (auction.auction_status == App_Models_Auction.STATUS_ACTIVE) {
            $bban.text("Bidding Is Open").addClass("bban-active");
        } else if (auction.auction_status == App_Models_Auction.STATUS_PUBLISHED) {
            $bban.text("Bidding Not Started").addClass("bban-closed");
        } else {
            $bban.text("Bidding Is Closed").addClass("bban-closed");
        }
    }

    static async on_click_lots() {
        _.AuctionUI_Router.navigate_to("lots");
    }

    // Same as above but registers for the auction after sign in
    static async on_click_registration() {
        let registrant = await _.AuctionUI_Session.get_registrant();
        
        // If user is a registrant but not registered for this auction, show registration modal
        if (registrant && !_.ac_state.registration) {
            _.ac_registeration_modal();
            return;
        }
        
        // If user is not a registrant (including backend users), show sign-in modal
        if (!registrant) {
            _.AuctionUI_Auction_General_UI.show_dialog_account_required_if_not_logged_in("You are not signed in, please create an account or sign in to bid:", async function () {
                if (!_.ac_state.registration) {
                    _.ac_registeration_modal();
                } else if (!_.ac_state.registration.approved) {
                    _.Modal.alert("Your registration is being reviewed, and is pending approval.");
                }
            });
            return;
        }
        
        // Handle registration pending approval
        if (_.ac_state.registration && !_.ac_state.registration.approved) {
            _.Modal.alert("Your registration is being reviewed, and is pending approval.");
        }
    }

    static async show_dialog_account_required_if_not_logged_in(message, callback) {
        // Only a registrant is signed in as a bidder. A staff user without a registrant must create one or
        // sign in with one (a different email signs the website out of the staff account).
        let registrant = await _.AuctionUI_Session.get_registrant();
        let backendUser = _.AuctionUI_Session.get_backend_user();

        if (!registrant) {
            if (backendUser) {
                message = "You are signed in as staff user " + backendUser.name + ", which is not a bidder account. Please create a bidder account or sign in with your bidder account:";
            }
            let option = await _.Modal.pick("Account Required",
                message,
                false, [
                {
                    title: "Create Account",
                    class: "btn-success",
                    value: "create",
                    default: false
                },
                {
                    title: "Sign In",
                    class: "btn-success",
                    value: "signin",
                    default: false
                },
                {
                    title: "Cancel",
                    class: "btn-secondary",
                    value: "cancel",
                    default: true
                }
            ]);
            if (option == 'create') {
                _.AuctionUI_Signup.signup_modal(callback);
            } else if (option == 'signin') {
                _.AuctionUI_Login.login_modal(callback);
            }
        } else {
            callback();
        }
    }



}